import { Component, Input, OnInit } from '@angular/core';
import moment from 'moment';

@Component({
    selector: 'app-validaton-errors',
    templateUrl: './validaton-errors.component.html',
    styleUrls: ['./validaton-errors.component.scss'],
    standalone: false
})
export class ValidatonErrorsComponent implements OnInit {

  @Input() control: any = null;
  @Input() controlName = 'field';
  @Input() language='English'
  constructor() { }

  ngOnInit(): void {
  }

  getFormattedDate(date: Date): string {
    return moment(date).format('M/D/YYYY, hh:mm a');
  }
}
